module.exports = __webpack_public_path__ + "static/media/7-10.710834c9.mp3";